import { render, staticRenderFns } from "./table1.vue?vue&type=template&id=ac971d32&scoped=true&"
import script from "./table1.vue?vue&type=script&lang=js&"
export * from "./table1.vue?vue&type=script&lang=js&"
import style0 from "./table1.vue?vue&type=style&index=0&id=ac971d32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac971d32",
  null
  
)

export default component.exports